import IMask from "imask";

window.addEventListener('load', () => {
    const phoneInputs = document.querySelectorAll(".js-input-phone");
    phoneInputs.forEach(input => {
        IMask(input, {
                mask: '+{7}(000)000-00-00'
            }
        )
    })

    const dateInputs = document.querySelectorAll('.js-input-date');
    dateInputs.forEach(input => {
        IMask(input, {
                mask: Date
            }
        )
    })

    const maintenanceAgreementInputs = document.querySelectorAll('.js-input-maintenance-agreement');
    maintenanceAgreementInputs.forEach(input => {
        IMask(input, {
                mask: '000000'
            }
        )
    })

    const certificateInputs = document.querySelectorAll('.js-input-certificate');
    const xReplacement = {
            mask: /[0-9,A-z]/,
            placeholderChar: 'X',
        }
    certificateInputs.forEach(input => {
        IMask(input, {
                mask: [
                    {
                        mask: 'XXX-XX-XX',
                        definitions: {
                            X: xReplacement
                        },
                    },
                    {
                        mask: 'XX-XXX-XXXXX',
                        definitions: {
                            X: xReplacement
                        },
                    }
                ]
            }
        )
    })
})
